import { FormField } from '../../../types/form-builder.types';

interface LikertScaleFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function LikertScaleField({ field, value, onChange }: LikertScaleFieldProps) {
  const config = field.config;
  const options = config.options || [];

  return (
    <div className="flex justify-between gap-2 md:gap-3">
      {options.map((option, index) => (
        <div key={option.id || `likert-${index}`} className="flex flex-col items-center flex-1 gap-2">
          <input
            type="radio"
            value={option.value}
            id={`${field.id}-${option.id}`}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            className="easyforms-option-input w-5 h-5"
          />
          <label
            htmlFor={`${field.id}-${option.id}`}
            className="font-light text-xs text-center cursor-pointer leading-tight"
            style={{ color: 'var(--ef-text, #1E293B)' }}
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
}
